export const DEMO_TOURNAMENT_ID = '12345678-1234-1234-1234-123456789012'
export const DEMO_ESPORTS_ID = '87654321-4321-4321-4321-210987654321'
export const DEMO_TENANT_ID = '00000000-0000-0000-0000-000000000000'

// --- FOOTBALL DEMO ---
export const demoTournament = {
    id: DEMO_TOURNAMENT_ID,
    name: '🏆 Champions League Demo 2026',
    status: 'published',
    tournament_type: 'poule',
    theme_color: '#004170', // Champions League Blue
    background_image: '/images/soccer%20crowd.webp',
    sponsor_left_image: JSON.stringify([
        'https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Coca-Cola_logo.svg/500px-Coca-Cola_logo.svg.png',
        'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/500px-Amazon_logo.svg.png',
        'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Orange_logo.svg/500px-Orange_logo.svg.png'
    ]),
    sponsor_right_image: JSON.stringify([
        'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Jumbo_Logo.svg/500px-Jumbo_Logo.svg.png',
        'https://upload.wikimedia.org/wikipedia/commons/2/24/Adidas_logo.png',
        'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Logo_NIKE.svg/500px-Logo_NIKE.svg.png'
    ]),
    is_public: true,
    tenant_id: DEMO_TENANT_ID,
    created_at: new Date().toISOString()
}

export const demoTeams = [
    { id: 't1', name: "Real Madrid", color: "#FFFFFF", logo_url: "https://upload.wikimedia.org/wikipedia/en/5/56/Real_Madrid_CF.svg", tournament_id: DEMO_TOURNAMENT_ID, tenant_id: DEMO_TENANT_ID },
    { id: 't2', name: "Manchester City", color: "#6CABDD", logo_url: "https://upload.wikimedia.org/wikipedia/en/e/eb/Manchester_City_FC_badge.svg", tournament_id: DEMO_TOURNAMENT_ID, tenant_id: DEMO_TENANT_ID },
    { id: 't3', name: "Bayern München", color: "#DC052D", logo_url: "https://upload.wikimedia.org/wikipedia/commons/1/1b/FC_Bayern_M%C3%BCnchen_logo_%282017%29.svg", tournament_id: DEMO_TOURNAMENT_ID, tenant_id: DEMO_TENANT_ID },
    { id: 't4', name: "Paris Saint-Germain", color: "#004170", logo_url: "https://upload.wikimedia.org/wikipedia/en/a/a7/Paris_Saint-Germain_F.C..svg", tournament_id: DEMO_TOURNAMENT_ID, tenant_id: DEMO_TENANT_ID },
    { id: 't5', name: "Liverpool", color: "#C8102E", logo_url: "https://upload.wikimedia.org/wikipedia/en/0/0c/Liverpool_FC.svg", tournament_id: DEMO_TOURNAMENT_ID, tenant_id: DEMO_TENANT_ID },
    { id: 't6', name: "Inter Milan", color: "#010E80", logo_url: "https://upload.wikimedia.org/wikipedia/commons/0/05/FC_Internazionale_Milano_2021.svg", tournament_id: DEMO_TOURNAMENT_ID, tenant_id: DEMO_TENANT_ID },
    { id: 't7', name: "Arsenal", color: "#EF0107", logo_url: "https://upload.wikimedia.org/wikipedia/en/5/53/Arsenal_FC.svg", tournament_id: DEMO_TOURNAMENT_ID, tenant_id: DEMO_TENANT_ID },
    { id: 't8', name: "FC Barcelona", color: "#004D98", logo_url: "https://upload.wikimedia.org/wikipedia/en/4/47/FC_Barcelona_%28crest%29.svg", tournament_id: DEMO_TOURNAMENT_ID, tenant_id: DEMO_TENANT_ID }
]

export const demoPoules = [
    { id: 'p1', name: 'Group A', tournament_id: DEMO_TOURNAMENT_ID, tenant_id: DEMO_TENANT_ID },
    { id: 'p2', name: 'Group B', tournament_id: DEMO_TOURNAMENT_ID, tenant_id: DEMO_TENANT_ID }
]

export const demoMatches = [
    // Poule A - Completed
    { id: 'm1', tournament_id: DEMO_TOURNAMENT_ID, poule_id: 'p1', home_team_id: 't1', away_team_id: 't2', score_home: 3, score_away: 1, status: 'completed', start_time: new Date().toISOString(), home_team: demoTeams[0], away_team: demoTeams[1], poule: demoPoules[0], field: 'Main Stadium' },
    { id: 'm2', tournament_id: DEMO_TOURNAMENT_ID, poule_id: 'p1', home_team_id: 't3', away_team_id: 't4', score_home: 2, score_away: 2, status: 'completed', start_time: new Date().toISOString(), home_team: demoTeams[2], away_team: demoTeams[3], poule: demoPoules[0], field: 'Field 2' },
    // Poule B - Completed
    { id: 'm3', tournament_id: DEMO_TOURNAMENT_ID, poule_id: 'p2', home_team_id: 't5', away_team_id: 't6', score_home: 1, score_away: 0, status: 'completed', start_time: new Date().toISOString(), home_team: demoTeams[4], away_team: demoTeams[5], poule: demoPoules[1], field: 'Arena' },
    { id: 'm4', tournament_id: DEMO_TOURNAMENT_ID, poule_id: 'p2', home_team_id: 't7', away_team_id: 't8', score_home: 2, score_away: 2, status: 'completed', start_time: new Date().toISOString(), home_team: demoTeams[6], away_team: demoTeams[7], poule: demoPoules[1], field: 'Field 3' },

    // Scheduled
    { id: 'm5', tournament_id: DEMO_TOURNAMENT_ID, poule_id: 'p1', home_team_id: 't2', away_team_id: 't3', score_home: null, score_away: null, status: 'scheduled', start_time: new Date(Date.now() + 3600000).toISOString(), home_team: demoTeams[1], away_team: demoTeams[2], poule: demoPoules[0], field: 'Main Stadium' },
    { id: 'm6', tournament_id: DEMO_TOURNAMENT_ID, poule_id: 'p1', home_team_id: 't4', away_team_id: 't1', score_home: null, score_away: null, status: 'scheduled', start_time: new Date(Date.now() + 3600000).toISOString(), home_team: demoTeams[3], away_team: demoTeams[0], poule: demoPoules[0], field: 'Field 2' },
    { id: 'm7', tournament_id: DEMO_TOURNAMENT_ID, poule_id: 'p2', home_team_id: 't8', away_team_id: 't5', score_home: null, score_away: null, status: 'scheduled', start_time: new Date(Date.now() + 3600000).toISOString(), home_team: demoTeams[7], away_team: demoTeams[4], poule: demoPoules[1], field: 'Arena' },
    { id: 'm8', tournament_id: DEMO_TOURNAMENT_ID, poule_id: 'p2', home_team_id: 't6', away_team_id: 't7', score_home: null, score_away: null, status: 'scheduled', start_time: new Date(Date.now() + 3600000).toISOString(), home_team: demoTeams[5], away_team: demoTeams[6], poule: demoPoules[1], field: 'Field 3' }
]

// --- ESPORTS DEMO ---
export const esportsTournament = {
    id: DEMO_ESPORTS_ID,
    name: '🎮 E-Sports Cup 2026',
    status: 'published',
    tournament_type: 'poule',
    theme_color: '#d946ef', // Esports Neon Fuchsia
    background_image: '/images/Esports_FC26.webp',
    sponsor_left_image: JSON.stringify([
        'https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Razer_logo.svg/500px-Razer_logo.svg.png',
        'https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Intel_logo_%282020-present%29.svg/512px-Intel_logo_%282020-present%29.svg.png',
        'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Logitech_G_logo.svg/500px-Logitech_G_logo.svg.png'
    ]),
    sponsor_right_image: JSON.stringify([
        'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Red_Bull_GmbH_logo.svg/1024px-Red_Bull_GmbH_logo.svg.png',
        'https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Monster_Energy_logo.svg/500px-Monster_Energy_logo.svg.png',
        'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Twitch_logo.svg/500px-Twitch_logo.svg.png'
    ]),
    is_public: true,
    tenant_id: DEMO_TENANT_ID,
    created_at: new Date().toISOString()
}

export const esportsTeams = [
    { id: 'e1', name: "FaZe Clan", color: "#FF0000", logo_url: "/images/faze_clan.svg", tournament_id: DEMO_ESPORTS_ID, tenant_id: DEMO_TENANT_ID },
    { id: 'e2', name: "Cloud9", color: "#00BFFF", logo_url: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Cloud9_logo.svg/500px-Cloud9_logo.svg.png", tournament_id: DEMO_ESPORTS_ID, tenant_id: DEMO_TENANT_ID },
    { id: 'e3', name: "G2 Esports", color: "#000000", logo_url: "/images/g2_esports.svg", tournament_id: DEMO_ESPORTS_ID, tenant_id: DEMO_TENANT_ID },
    { id: 'e4', name: "Fnatic", color: "#FF5900", logo_url: "https://upload.wikimedia.org/wikipedia/en/thumb/4/43/Fnatic_logo.svg/500px-Fnatic_logo.svg.png", tournament_id: DEMO_ESPORTS_ID, tenant_id: DEMO_TENANT_ID },
    { id: 'e5', name: "Team Liquid", color: "#002F6C", logo_url: "https://upload.wikimedia.org/wikipedia/en/thumb/f/f1/Team_Liquid_logo.svg/500px-Team_Liquid_logo.svg.png", tournament_id: DEMO_ESPORTS_ID, tenant_id: DEMO_TENANT_ID },
    { id: 'e6', name: "Natus Vincere", color: "#FFF200", logo_url: "https://upload.wikimedia.org/wikipedia/en/thumb/a/ac/NaVi_logo.svg/500px-NaVi_logo.svg.png", tournament_id: DEMO_ESPORTS_ID, tenant_id: DEMO_TENANT_ID },
    { id: 'e7', name: "Vitality", color: "#FFFF00", logo_url: "https://upload.wikimedia.org/wikipedia/en/thumb/8/8b/Team_Vitality_logo.svg/500px-Team_Vitality_logo.svg.png", tournament_id: DEMO_ESPORTS_ID, tenant_id: DEMO_TENANT_ID },
    { id: 'e8', name: "T1", color: "#E4002B", logo_url: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/T1_Logo.svg/500px-T1_Logo.svg.png", tournament_id: DEMO_ESPORTS_ID, tenant_id: DEMO_TENANT_ID }
]

export const esportsPoules = [
    { id: 'ep1', name: 'Bracket A', tournament_id: DEMO_ESPORTS_ID, tenant_id: DEMO_TENANT_ID },
    { id: 'ep2', name: 'Bracket B', tournament_id: DEMO_ESPORTS_ID, tenant_id: DEMO_TENANT_ID }
]

export const esportsMatches = [
    // Bracket A - Completed
    { id: 'em1', tournament_id: DEMO_ESPORTS_ID, poule_id: 'ep1', home_team_id: 'e1', away_team_id: 'e2', score_home: 2, score_away: 1, status: 'completed', start_time: new Date().toISOString(), home_team: esportsTeams[0], away_team: esportsTeams[1], poule: esportsPoules[0], field: 'Main Stage' },
    { id: 'em2', tournament_id: DEMO_ESPORTS_ID, poule_id: 'ep1', home_team_id: 'e3', away_team_id: 'e4', score_home: 0, score_away: 2, status: 'completed', start_time: new Date().toISOString(), home_team: esportsTeams[2], away_team: esportsTeams[3], poule: esportsPoules[0], field: 'Stream A' },
    // Bracket B - Completed
    { id: 'em3', tournament_id: DEMO_ESPORTS_ID, poule_id: 'ep2', home_team_id: 'e5', away_team_id: 'e6', score_home: 2, score_away: 2, status: 'completed', start_time: new Date().toISOString(), home_team: esportsTeams[4], away_team: esportsTeams[5], poule: esportsPoules[1], field: 'Stream B' },

    // Live Match in Progress
    { id: 'em4', tournament_id: DEMO_ESPORTS_ID, poule_id: 'ep1', home_team_id: 'e2', away_team_id: 'e3', score_home: 1, score_away: 1, status: 'live', start_time: new Date().toISOString(), home_team: esportsTeams[1], away_team: esportsTeams[2], poule: esportsPoules[0], field: 'Main Stage' }
]


export const demoSlides = [
    { id: 's1', type: 'standing', duration: 15, sort_order: 1 },
    { id: 's2', type: 'matches', duration: 15, sort_order: 2 },
    { id: 's3', type: 'program', duration: 15, sort_order: 3 }
]

// --- HELPER FUNCTIONS ---

export const isDemoTournament = (id) => {
    return id === DEMO_TOURNAMENT_ID || id === DEMO_ESPORTS_ID;
}

export const getDemoTournament = (id) => {
    if (id === DEMO_ESPORTS_ID) return esportsTournament;
    return demoTournament;
}

export const getDemoTeams = (id) => {
    if (id === DEMO_ESPORTS_ID) return esportsTeams;
    return demoTeams;
}

export const getDemoMatches = (id) => {
    if (id === DEMO_ESPORTS_ID) return esportsMatches;
    return demoMatches;
}

export const getDemoPoules = (id) => {
    if (id === DEMO_ESPORTS_ID) return esportsPoules;
    return demoPoules;
}
